import { trackUsage } from "../mutations/trackUsage.subscriptions.js";
import { METERED_VARIABLES, getMeteredVariableId, } from "../getMeteredVariables.js";
import { getSubscriptionContractDetails } from "./getSubscriptionContractDetails.js";
export const trackProgressionIndex = async ({ contractId, sku }, { client }) => {
    const { plan } = await getSubscriptionContractDetails({ contractId }, { client });
    const meteredVariableId = getMeteredVariableId({
        subscriptionPlan: plan,
        identifier: METERED_VARIABLES.PROGRESSION_INDEX,
    });
    if (!meteredVariableId) {
        throw new Error(`Contract type does not support ${METERED_VARIABLES.PROGRESSION_INDEX}: Subscription plan type: ${plan.identifier}}`);
    }
    await trackUsage({
        contractId,
        meteredVariableId,
        quantity: 1,
        idempotencyKey: sku,
        description: `${contractId}: Tracked progression index ${sku} by file import`,
    }, { client });
};
